import { Box, Typography } from '@mui/material';
import { TagContainer } from 'components';
import { useNavigate } from 'react-router-dom';
import { useSystemActions } from 'stores';
import { FeedbackHistoryProps } from 'types';

const FeedbackTag = (props: { rowData: FeedbackHistoryProps }) => {
	const { rowData } = props;
	const navigate = useNavigate();
	const { resolveMultiLang } = useSystemActions();

	const handleClick = async () => {
		navigate('/FeedbackDetail', { state: { id: rowData.id.toString() } });
	};

	return (
		<>
			<TagContainer
				tagContent={
					<>
						<Box
							pl={1}
							sx={{
								width: '100%',
								display: 'flex',
								flexDirection: 'column',
								alignItems: 'flex-start',
							}}
						>
							<Typography
								variant="subtitle2"
								sx={{ color: 'black' }}
								pl={0.5}
							>
								{resolveMultiLang(rowData.productName)}
							</Typography>
							<Typography
								variant="caption"
								sx={{ color: 'gray' }}
								pl={0.5}
							>
								{rowData.title}
							</Typography>
							<Typography
								variant="caption"
								sx={{ color: 'gray' }}
								pl={0.5}
							>
								{new Date(rowData.createDate)
									.toLocaleString('zh-CN', {
										hour12: false,
									})
									.replace(/\//g, '-')}
							</Typography>
						</Box>
					</>
				}
				img={rowData.productImg}
				onClick={handleClick}
			/>
		</>
	);
};

export default FeedbackTag;
